var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-8"},[_c('div',{staticClass:"bg-white shadow-lg w-full rounded-xl p-6"},[_vm._v(" 更新日志 ")])])
}]

export { render, staticRenderFns }